import React from 'react';
import { Badge } from './ui/badge';
import { Building2, MapPin, TrendingUp } from 'lucide-react';

const STATUS_LABELS = {
  'new': 'New',
  'lead': 'New Lead',
  'contacted': 'Contacted',
  'walkthrough_scheduled': 'Walkthrough Scheduled',
  'proposal_sent': 'Proposal Sent',
  'won': 'Won',
  'lost': 'Lost',
  'draft': 'Draft',
  'sent': 'Sent',
  'viewed': 'Viewed',
  'accepted': 'Accepted',
  'rejected': 'Rejected',
  'active': 'Active',
  'inactive': 'Inactive',
  'completed': 'Completed'
};

const STATUS_VARIANTS = {
  'new': 'secondary',
  'lead': 'secondary',
  'contacted': 'outline',
  'walkthrough_scheduled': 'default',
  'proposal_sent': 'default',
  'sent': 'default',
  'won': 'success',
  'accepted': 'success',
  'lost': 'destructive',
  'rejected': 'destructive',
  'draft': 'outline',
  'viewed': 'outline',
  'active': 'success',
  'completed': 'success'
};

export function RecordContextHeader({ 
  label,
  company, 
  facility, 
  status, 
  additionalInfo,
  className = ""
}) {
  const statusLabel = STATUS_LABELS[status] || status;
  const statusVariant = STATUS_VARIANTS[status] || 'default';

  return (
    <div className={`bg-gradient-to-r from-slate-50 to-slate-100 dark:from-slate-900 dark:to-slate-800 border-b border-slate-200 dark:border-slate-700 border-l-4 border-l-teal-600 px-6 py-3 ${className}`}>
      {label && (
        <div className="text-xs uppercase tracking-wide text-slate-500 dark:text-slate-400 font-semibold mb-2">
          {label}
        </div>
      )}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          {company && (
            <div className="flex items-center gap-2">
              <Building2 className="h-4 w-4 text-slate-500" />
              <span className="font-semibold text-slate-900 dark:text-slate-100">{company}</span>
            </div>
          )}
          {facility && (
            <>
              <span className="text-slate-300">•</span>
              <div className="flex items-center gap-2">
                <MapPin className="h-4 w-4 text-slate-500" />
                <span className="text-slate-600 dark:text-slate-400">{facility}</span>
              </div>
            </>
          )}
          {additionalInfo && (
            <>
              <span className="text-slate-300">•</span>
              <span className="text-sm text-slate-500">{additionalInfo}</span>
            </>
          )}
        </div>
        {status && (
          <Badge variant={statusVariant} className="capitalize">
            {statusLabel}
          </Badge>
        )}
      </div>
    </div>
  );
}

export function getStatusLabel(status) {
  return STATUS_LABELS[status] || status;
}

export function getStatusVariant(status) {
  return STATUS_VARIANTS[status] || 'default';
}
